(function () {
  if (window.__AG_PB_SALE_OFFER_INIT__) return;
  window.__AG_PB_SALE_OFFER_INIT__ = true;

  // The Eyr campaign engine adds the campaign's gifts after the cart changes. Going to checkout straight away
  // would leave the page before it has, so wait for its check (at most 4 seconds), then go.
  function agGoToCheckout() {
    var engine = window.EyrCampaignEngine;
    var go = function () { window.location.href = '/checkout'; };
    if (!engine || typeof engine.sync !== 'function') return go();
    var done = false;
    var once = function () { if (!done) { done = true; go(); } };
    setTimeout(once, 4000);
    try { Promise.resolve(engine.sync()).then(once, once); } catch (e) { once(); }
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function initGallery(root) {
    var track = qs('[data-ag-pb-so-track]', root);
    var slides = qsa('[data-ag-pb-so-slide]', root);
    var prev = qs('[data-ag-pb-so-prev]', root);
    var next = qs('[data-ag-pb-so-next]', root);
    if (!track || slides.length < 2) return;

    var index = 0;
    var dragging = false;
    var pointerId = null;
    var startX = 0;
    var deltaX = 0;
    var width = 0;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      slides.forEach(function (slide, n) {
        var active = n === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      pointerId = e.pointerId;
      startX = e.clientX;
      deltaX = 0;
      width = track.getBoundingClientRect().width || 1;
      track.style.transition = 'none';
      if (track.setPointerCapture) {
        try {
          track.setPointerCapture(pointerId);
        } catch (err) {}
      }
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      deltaX = e.clientX - startX;
      var percent = (deltaX / width) * 100;
      track.style.transform = 'translateX(' + (-index * 100 + percent) + '%)';
    }

    function endDrag(e) {
      if (!dragging || (e && e.pointerId !== pointerId)) return;
      dragging = false;
      pointerId = null;
      track.style.transition = '';

      var threshold = Math.max(40, width * 0.15);
      if (deltaX <= -threshold) {
        goTo(index + 1);
      } else if (deltaX >= threshold) {
        goTo(index - 1);
      } else {
        goTo(index);
      }
      deltaX = 0;
    }

    track.style.touchAction = 'pan-y';
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    goTo(0);
  }

  function openMiniCart(cartData) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cartData, openMiniCart: true }
      })
    );

    var cartDrawer = document.querySelector('cart-drawer, #mini-cart');
    if (cartDrawer) {
      cartDrawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    if (typeof updateCartItemCount === 'function') {
      updateCartItemCount();
    }

    document.dispatchEvent(new CustomEvent('cart:changed', { bubbles: true }));
  }

  function initAtc(root) {
    var form = qs('[data-ag-pb-so-atc-form]', root);
    if (!form || form.dataset.agPbSoAtcReady === 'true') return;
    form.dataset.agPbSoAtcReady = 'true';

    var mode = (form.getAttribute('data-cta-mode') || 'checkout').toLowerCase();
    var inflight = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (inflight) return;

      var idInput = qs('input[name="id"]', form);
      var spInput = qs('input[name="selling_plan"]', form);
      var qtyInput = qs('input[name="quantity"]', form);
      var variantId = idInput ? String(idInput.value || '').trim() : '';
      var spRaw = spInput ? String(spInput.value || '').trim() : '';
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      if (!/^\d+$/.test(variantId)) {
        console.error('[AG Sale Offer] Missing/invalid variant id');
        return;
      }

      var item = { id: Number(variantId), quantity: qty };
      // Keep selling_plan as digit string — Number() truncates large Shopify plan ids → OTP add
      if (/^\d+$/.test(spRaw)) item.selling_plan = spRaw;

      var btn = qs('[data-ag-pb-so-atc-btn]', form);
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      inflight = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw body;
            return body;
          });
        })
        .then(function (addBody) {
          if (mode === 'checkout') {
            agGoToCheckout();
            return;
          }

          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              openMiniCart(cart || addBody);
            })
            .catch(function () {
              openMiniCart(addBody);
            });
        })
        .catch(function (err) {
          console.error('[AG Sale Offer ATC ERROR]', err);
        })
        .finally(function () {
          inflight = false;
          if (btn && mode !== 'checkout') {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
    });
  }

  function initBlock(root) {
    if (!root || root.dataset.agPbSoReady === 'true') return;
    root.dataset.agPbSoReady = 'true';
    initGallery(root);
    initAtc(root);
  }

  function initAll(scope) {
    var rootEl = scope && scope.querySelectorAll ? scope : document;
    qsa('.js-ag-pb-sale-offer', rootEl).forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    qsa('.js-ag-pb-sale-offer', e.target).forEach(function (root) {
      delete root.dataset.agPbSoReady;
      var form = qs('[data-ag-pb-so-atc-form]', root);
      if (form) delete form.dataset.agPbSoAtcReady;
      initBlock(root);
    });
  });
})();
